###
Advanced branching interface implementation for the survey editor.
###

BranchingRule = require('sma.fs/surveys/offline/logic.coffee').BranchingRule
LogicNode = require('sma.fs/surveys/offline/logic.coffee').LogicNode
SurveyAction = require('sma.fs/surveys/offline/logic.coffee').SurveyAction
Utils = require('sma.fs/surveys/utils')
Nodes = require('sma.admin/components/filters/nodes')
Filter = require('sma.admin/components/filters/filters')
Modals = require('sma.common/components/modals')

class BranchValidationError extends Error
	constructor: (config) ->
		super(config)
		_.extend this, config

###
Backbone view which renders a single action for a branching rule. If
no previous action is passed in as the config, then the dropdown starts
with a "please select" option and class="inactive". Selecting an action type
causes the row to become active and a new inactive row to appear below.
###
class BranchAction extends Backbone.View
	transfix: [
		gettext('Edit Rule')
		gettext('Save Rule')
	]

	events:
		'change select.action': 'onActionChanged'
		'click a.remove': 'remove'

	tagName: 'li'

	initialize: (config) ->
		_.bindAll this, 'onActionChanged', 'remove'

		@dialog = config.dialog
		@action = config?.action
		@actionOptions = $('<div class="action-options"/>')

		@$el = $(@$el)
		$(@$el).data('view', this)

	remove: ->
		@$el.remove()
		return false

	actionType: -> @$('.action').val()

	onActionChanged: ->
		if @$el.hasClass('inactive') and @actionType()
			@$('.action .light').prop('disabled', true)

			# add a blank row after
			@$el.removeClass('inactive')

			next = new BranchAction
				dialog: @dialog

			# let's slide it down for prettiness
			next.$el.insertAfter(@$el)

			next.render().hide().slideDown().fadeIn()

		@refreshActionOptions()

	render: ->
		# add a delete icon on the right end of the row, but only if we're not the first
		@$el.empty()

		first = @$el.parent().children(':first').is(@$el)

		if not first
			@$el.html '''
			<div class="float-right"><a href="#" class="icon icon-only icon-delete remove">Delete</a></div>
			'''

		action = @renderActions(first)

		if @action?.type
			action.find('.light').prop('disabled', true)
			action.val(@action?.type)

		@$el.addClass('inactive') if not @action

		@$el.append action, @actionOptions

		@refreshActionOptions()

		return @$el

	# Returns true if the survey contains at least one DocuSign question.
	_surveyHasDocuSign: ->
		@dialog.survey.pages.some (page) ->
			page.fields.some (field) -> field.type == 'docusign-signature'

	# Build the actions dropdown. The branch parameter is true if this is the first rule action
	# and should include skipping options.
	renderActions: (branch=true) ->
		opt = (type) -> $ '<option/>',
			value: type
			text: SurveyAction.TYPES[type]::label

		group = (label, items) -> $('<optgroup/>').attr('label', label).append (opt(item) for item in items)...

		hasDocuSign = @_surveyHasDocuSign()

		branchingActions = ['skip', 'finish', 'terminate', 'random']

		if @dialog.survey.pages.length == 1+ @dialog.survey.currentPage.index
			branchingActions = ['finish', 'terminate']

		if @dialog.survey.currentPage.isLooped()
			branchingActions.push 'continue'

		# Prevent actions that would bypass DocuSign signing on forms that contain a DocuSign question.
		if hasDocuSign
			branchingActions = branchingActions.filter (a) -> a not in ['finish', 'terminate']

		if branch
			advancedActions = ['redirect', 'mark-complete', 'random-range']

			if @dialog.survey.pages.length == 1 + @dialog.survey.currentPage.index
				advancedActions = ['redirect', 'mark-complete']
		else
			advancedActions = ['mark-complete']

		if hasDocuSign
			advancedActions = advancedActions.filter (a) -> a != 'mark-complete'

		dynamicActions = ['hide', 'show', 'disable', 'mark-invalid', 'hide-page']
		if hasDocuSign
			dynamicActions = dynamicActions.filter (a) -> a != 'hide-page'

		action = $('<select class="action custom-select" name="action" />').append(
			$('<option class="light" value="" />').html(gettext('Select an action...')))

		if branch and branchingActions.length > 0
			action.append group(gettext('Branching'), branchingActions)

		action.append(
			group(gettext('Dynamic'), dynamicActions),
			group(gettext('Advanced'), advancedActions))

		return action

	refreshActionOptions: ->
		@actionOptions.empty()

		# FIXME: could be split into separate classes
		switch @actionType()
			when 'hide', 'show', 'disable'
				selector = Utils::buildSourceDropdown @dialog.survey.formatInfo(),
					showEmpty: true
					varPred: true
					questionPred: (question) -> question.type != 'docusign-signature'
					pagePred: (page) => page.index >= @dialog.page.index
					showRowsAndColumns: true
					show3DVariables: false

				selector.attr('name', 'target')

				if @action?.getTargetId?
					selector.val @action.getTargetId()

				@actionOptions.append selector

			when 'mark-invalid'
				selector = Utils::buildSourceDropdown @dialog.survey.formatInfo(),
					showEmpty: true
					varPred: true
					questionPred: (question) -> question.type != 'docusign-signature'
					pagePred: (page) => page.index >= @dialog.page.index
					showRowsAndColumns: true
					show3DVariables: false

				selector.attr('name', 'target')

				if @action?.getTargetId?
					selector.val @action.getTargetId()

				@actionOptions.append selector

				el =  $('<input type="text" class="text invalid-msg form-control" name="feedback" rel="tooltip" placeholder="Enter the message when the question is invalid"/>')
				el.val @action?.feedback if @action?.feedback
				@actionOptions.append el

			when 'skip'
				selector = $('<select name="page" class="custom-select" />')

				for page in @dialog.survey.pages
					if page.index > @dialog.page.index
						selector.append $('<option/>').val(page.id).text(page.label.display())

				@actionOptions.append selector

				selector.val @action.page if @action?.page

			when 'hide-page'
				selector = $('<select name="page" class="custom-select" />')

				for page in @dialog.survey.pages
					if page.index > @dialog.page.index
						pageHasDocuSign = page.fields.some (field) -> field.type == 'docusign-signature'
						unless pageHasDocuSign
							selector.append $('<option/>').val(page.id).text(page.label.display())

				@actionOptions.append selector

				# load the page into the dropdown
				selector.val @action.page if @action?.page

			when 'redirect'
				el = $('<input type="text" class="text form-control" name="url" />').appendTo @actionOptions

				# load the url into the dropdown
				el.val @action?.url if @action?.url

			when 'random'
				el = $('<input type="text" class="text form-control" name="pages" />').appendTo @actionOptions

				page_re = RegExp('^([0-9]+,)*[0-9]+$')

				el.bind 'focusout', () ->
					$(this).val($(this).val().replace(/\s/g, ''))
					if !page_re.test $(this).val()
						new sma.components.Alert
							message: gettext('Please enter a comma-separated list of values (example: 4,5,6)'),
							type: 'warning'

						$(this).val('')

				# load the url into the dropdown
				el.val @action?.pages if @action?.pages

			when 'random-range'
				el = $('<input type="text" class="text form-control" name="pages" rel="tooltip" title="Enter a comma-separated list of pages"/>').appendTo @actionOptions

				page_re = RegExp('^([0-9]+,)+[0-9]+$')

				el.bind 'focusout', () ->
					$(this).val($(this).val().replace(/\s/g, ''))
					if !page_re.test $(this).val()
						new sma.components.Alert
							message: gettext('Please enter a comma-separated list of values (example: 4,5,6)'),
							type: 'warning'

						$(this).val('')

				# load the url into the dropdown
				el.val @action?.pages if @action?.pages

				@actionOptions.append gettext(' then skip to ')

				selector = $('<select name="after" class="custom-select" />')

				for page in @dialog.survey.pages
					if page.index > @dialog.page.index
						selector.append $('<option/>').val(page.id).text(page.label.display())

				@actionOptions.append selector

				# load the page into the dropdown
				selector.val @action.after if @action?.after


	serialize: ->
		type = @actionType()
		cls = SurveyAction.TYPES[type]

		# serialize any input elements into {name: value}
		options = {}
		for {name, value} in @actionOptions.find(':input').serializeArray()
			options[name] = value

		# function which throws error on validation failure
		error = => throw new BranchValidationError(target: this)
		# FIXME: more validation. Also, maybe should be calling action class' validate instead?
		action = switch type
			when 'finish', 'terminate', 'continue', 'mark-complete' then new cls()
			when 'skip', 'hide-page' then new cls(options.page)
			when 'hide', 'disable', 'show'
				error() if options.target == '-'

				new cls(options.target)
			when 'mark-invalid'
				error() if options.target == '-'

				new cls(options.target, options.feedback)
			when 'redirect'
				error() if not options.url

				new cls(options.url)
			when 'random'
				error() if not options.pages

				new cls(options.pages)
			when 'random-range'
				error() if not options.pages

				new cls(options.pages, options.after)
		return action

###
Dialog pane for a single branching rule, allows editing both the rule
condition logic and the resulting survey actions. The @model is an
instance of BranchingRule.
###
class BranchingRuleView extends Backbone.View
	trans:
		ruleCondition: gettext("Conditions")
		ruleActions: gettext("Do these Actions")

	initialize: (config) ->
		@dialog = config?.dialog
		@survey = @dialog?.survey

	render: ->
		that = this
		@$el.html _.template("""
		<h3>""" + BranchingRuleView.prototype.trans.ruleCondition + """</h3>
		<div class="branching-condition mb-4"></div>
		<h3>""" + BranchingRuleView.prototype.trans.ruleActions + """</h3>
		<ol class="branching-actions"></ol>
		""")

		survey_info = @survey.formatInfo()
		survey_info.collector_variables = []

		survey_info.isBranching = true

		questions = {}

		for index,page of survey_info.pages
			questions[page.page] = {data: []}
			for key,value of page.questions
				if survey_info.questions[value].type not in ['section-separator', 'javascript']
					questions[page.page].data.push survey_info.questions[value]

			if questions[page.page].data.length == 0
				delete questions[page.page]

		variables = []

		for key,value of survey_info.variables
			variables.push value

		questions['Variables'] = {data: variables}

		if @model
			current_filters = @model.condition.serialize(survey_info)

			if !current_filters.items?
				current_filters = {type: 'AND', items: [current_filters]}
		else
			current_filters = {}

		@condition = new Filter({}, {filters: questions, current_filters: current_filters})

		@$('.branching-condition').append @condition.element

		$(@condition.element).find('select:eq(0)').blur (e) ->
			if !$(@).val()
				$(@).val('-')

		# note that we append actions before rendering, so that the they what index they are
		for action in (@model?.actions) ? []
			el = new BranchAction
				action: action
				dialog: @dialog

			@$('.branching-actions').append el.$el

			el.render()

		el = new BranchAction
			dialog: @dialog

		@$('.branching-actions').append el.$el

		el.render()

		return @$el

	serialize: ->
		try
			condition = LogicNode::parse @condition.serialize(true)
		catch e
			new sma.components.Alert
				message: e.message,
				type: 'error'
			$(e.element).stop().css('background-color', 'transparent').effect('highlight', {color: '#d06460'}, 6000)
			return

		actions = []

		_.each $('.branching-actions > li:not(.inactive)'), (el) ->
			if (action = $(el).data('view').serialize())
				actions.push action

		return {condition, actions}

class AdvancedBranching extends Backbone.View
	translatables:
		addBranchingRule: gettext('Add Branching Rule')
		deleteRule: gettext('Delete')
		noBranchingRules: gettext('This page currently has no branching rules.')
		addNewRule: gettext('Add a new rule')
		otherwise: gettext('If no other branching conditions apply, skip to')
		branchingOrder: gettext('Branching rules are applied in the order they appear in this list')
		editRule: gettext('Edit')
		reorderRule: gettext('Reorder')

	maketemplate: _.wrap(_.template, (f, templateString, context) ->
			val = f(templateString, context)
			if not _.isFunction(val)
				return val
			else
				return _.wrap val, (func, context, isntance) ->
					return func
						data: _.extend {}, context
						trans: @translatables
		)
	template: @::maketemplate """
		<div class='tools row'>
			<div class="col-12">
				<a href='#' class='float-right btn btn-primary btn-loud new-rule'>
					<span class='icon icon-add'><%- trans.addBranchingRule %></span>
				</a>
			</div>
		</div>
		<% if (data.branching.length) { %>
			<div class="ml-5 mt-3"><%- trans.branchingOrder %></div>
			<ol class='branching-rules'>
			<% _.each(data.branching, function(rule, i) { %>
				<li data-index='<%- i %>'>
					<div class='float-right'>
						<div class="sma-branching-actions">
							<a href='#' class='edit ml-4' title="<%- trans.editRule %>">
								<i class="nc-icon-mini ui-1_pencil"></i>
							</a>
							<a href='#' class='move ml-4' title="<%- trans.reorderRule %>">
								<i class="nc-icon-mini gestures_drag-31"></i>
							</a>
							<a href='#' class='remove ml-4' title="<%- trans.deleteRule %>">
								<i class="nc-icon-mini ui-1_trash-simple"></i>
							</a>
						</div>
					</div>
					<%- rule.format(data.survey.formatInfo()) %>
				</li>
			<% }) %>
			</ol>
		<% } else { %>
			<div class='empty-help'>
				<%- trans.noBranchingRules %>
			</div>
		<% } %>
		<% if (data.survey.pages.length > 1) { %>
			<div class="text-center">
				<%- trans.otherwise %> <span class='otherwise'></span>
			</div>
		<% } %>
	"""

	events:
		'click .new-rule': 'newRuleClicked'
		'click .branching-rules li': 'ruleClicked'
		'click .branching-rules li a.remove': 'deleteRuleClicked'

	className: 'branching-dialog'

	# updates branching rules to new format and parses into BranchingRule objects
	@updateRules: (survey, branching) ->
		rules = []
		# only keep valid rules
		for rule in branching ? []
			rule = BranchingRule::parse(rule)
			if rule? and rule.validate(survey)
				rules.push rule
		return rules

	@formatRules: (survey, branching) -> (rule.format(survey.formatInfo()) for rule in @updateRules(survey.formatInfo(), branching))

	# converts any page IDs in the branching to page indexes for saving
	@unserializePageIDs: (survey, branching) ->
		for rule in branching
			for action in (rule.actions ? [rule.action])
				if action.page?
					action.page = (survey.pageMapping ? survey.pages)[action.page].index
				if action.after?
					action.after = (survey.pageMapping ? survey.pages)[action.after].index
		return branching

	initialize: (config={}) ->
		_.bindAll this, 'newRuleClicked', 'ruleClicked', 'deleteRuleClicked', 'updateRuleOrder'

		@survey = config.survey
		@page = config.page
		@callback = config.callback
		# FIXME: do conversion into BranchingRule objects when loading in editor.js
		@branching = @constructor.updateRules(@survey.formatInfo(), config.branching ? [])

		# Save initial branching rules for comparison when closing dialog. This
		# could throw an error (some old surveys have invalid branching), so simply
		# skip otherwise.
		try
			@initialBranching = @serialize()
		catch e
			@initialBranching = []

		@ruleView = new BranchingRuleView
			dialog: this

	serialize: ->

		rule.serialize(@survey.formatInfo()) for rule in @branching

	render: ->
		@$el.html @template this

	show: ->
		if !@dialog
			@dialog = new Modals.ContentModal(
				@el,
					title: gettext('Branching Editor')
					buttons: []
					size: 'lg'
					onClose: () =>
						@showRules()
			)

		@dialog.show()

		@showRules()

	showRules: ->
		try
			@$el.html @template this

			$('.branching-rules').sortable
				update: @updateRuleOrder

			@dialog.setButtons [{
				label: gettext('Cancel'),
				cls: 'btn btn-link btn-loud',
				handler: (modal) =>
					modal.hide()
			}, {
				label: gettext('Save')
				cls: 'btn btn-primary btn-loud'
				handler: (modal) =>
					branching = @serialize()
					@callback branching, @$('.otherwise select').val()
					modal.hide()
			}]

			$('.otherwise').append @page.renderBranchingSelect()

			$('.branching-rules').sortable
				update: @updateRuleOrder
		catch
			branching = @serialize()

			if branching.length > 0
				@dialog.hide()

				@dialog = new Modals.CheckboxModal(
					gettext('Clear Branching'),
					gettext('Because of a change that was made to this form, the branching rules on this page are no longer valid. Please click the “Clear All Branching” button below to resolve this. <br/> <b>Note: </b>This will remove all branching rules on this page and this action cannot be undone.'),
					gettext('I understand that this action will only impact rules on this page and that I will need to recreate any required branching rules.'),
					() =>
						branching = []
						@callback branching, @$('.otherwise select').val()
					,
						okLabel: gettext('Clear All Branching')
						destroyOnClose: true,
						contingent: true,
						isDelete: true
				)

		return @$el

	# Update @branching according to the new order of rules in the DOM.
	updateRuleOrder: ->
		branching = []
		@$('.branching-rules li').each (i, el) =>
			branching.push @branching[$(el).data('index')]
			$(el).data('index', i)
		@branching = branching

	editRule: (rule) ->
		###
		Note that we disable closeOnEscape because with all the dropdowns and form inputs
		in this dialog the user is likely to press escape, which would destroy all changes.
		Passing rule=false skips the view rendering but updates the dialog title/buttons.
		###
		@dialog.setTitle gettext('Branching Editor') + ' &mdash; ' + gettext('Edit Rule')

		@dialog.setButtons [{
			label: gettext('Cancel')
			cls: 'btn btn-link btn-loud'
			handler: => @showRules()
		}, {
			label: gettext('Save Rule')
			cls: 'btn btn-primary btn-loud'
			handler: =>
				try
					serialized = @ruleView.serialize()
				catch e
					e.target.$el.effect('highlight', {color: '#d06460'}, 6000)

				return if not serialized?

				if serialized.condition == null
					new sma.components.Alert
						message: gettext('Please add at least one condition.'),
						type: 'danger'

					return

				if not serialized.actions.length
					new sma.components.Alert
						message: gettext('Please add at least one branching action.'),
						type: 'danger'

					return

				model = @ruleView.model

				if not model
					@branching.push(model = new BranchingRule())

				model.actions = serialized.actions
				model.condition = serialized.condition

				@showRules()

		}]

		if rule != false
			@ruleView.model = rule
			@ruleView.page = @page.index
			@$el.empty().append @ruleView.render()

	ruleClicked: (e) ->
		e.preventDefault()

		@editRule @branching[@$('.branching-rules li').index(e.currentTarget)]

	deleteRuleClicked: (e) ->
		e.preventDefault()

		new Modals.Confirm gettext('Remove rule'), gettext("Are you sure you want to remove this rule?"), () =>
			row = $(e.currentTarget).closest('li')
			index = @$('.branching-rules li').index(row)

			@branching.splice(index, 1)
			@render()

		return false

	newRuleClicked: (e) ->
		e.preventDefault()

		@editRule()

		return false

module.exports = AdvancedBranching
